import React from "react";
import { IconButton } from "../button";
import { IconHeart, IconHeartFull } from "../icons";
import { Image } from "../image/image";
import { CSS_CLASSES } from "./carousel-css-classes";
import { CarouselImageProps } from "./carousel.types";

const FAVORITE_ICON_SIZE = 22;

export const CarouselImage = ({
  color = "interactive",
  showFavorite = false,
  favorite = false,
  onFavoriteClick,
  ...restProps
}: CarouselImageProps) => {
  return (
    <>
      {showFavorite && (
        <IconButton
          icon={favorite ? <IconHeartFull size={FAVORITE_ICON_SIZE} /> : <IconHeart size={FAVORITE_ICON_SIZE} />}
          color={favorite ? color : "gray"}
          variant="ghost"
          label="favorite"
          className={CSS_CLASSES.CAROUSEL_HEART}
          onClick={onFavoriteClick}
          styleOverride="normal"
        />
      )}
      <Image {...restProps} />
    </>
  );
};

CarouselImage.displayName = "CarouselImage";
